import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-design',
  standalone: false,
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DesignComponent { }
